"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var Loader = function Loader(_ref) {
  var _ref$loadingSize = _ref.loadingSize,
    loadingSize = _ref$loadingSize === void 0 ? 20 : _ref$loadingSize,
    _ref$loadingColor = _ref.loadingColor,
    loadingColor = _ref$loadingColor === void 0 ? "#B5B5B5" : _ref$loadingColor;
  return _react["default"].createElement("svg", {
    width: loadingSize,
    height: loadingSize,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid"
  }, _react["default"].createElement("circle", {
    cx: "50",
    cy: "50",
    fill: "none",
    stroke: loadingColor,
    strokeWidth: "10",
    r: "35",
    strokeDasharray: "164.93361431346415 56.97787143782138",
    transform: "rotate(215.545 50 50)"
  }, _react["default"].createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "linear",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  })));
};
var _default = Loader;
exports["default"] = _default;